<div class="e-infographics-container" role="region">
    <ng-content></ng-content>
</div>
